<template>
    <section class="container h-full my-10 lg:my-16">
        <div
            class="bg-black bg-opacity-60 rounded-2xl h-full py-10 lg:py-20 px-4 lg:px-36 flex flex-col items-center justify-center"
        >
            <h2 class="text-title-md font-bold text-gray-200 mb-4 leading-5 mx-auto">{{ item?.title }}</h2>
            <div class="text-gray-400 text-body-md leading-5 lg:text-center mb-4 text-start grid gap-y-3">
                <p v-for="item in item.description">{{ item }}</p>
            </div>
            <TransitionExpand :duration="800">
                <div
                    v-if="showMore && item.moreDescription"
                    class="text-gray-400 text-body-md leading-5 lg:text-center text-start grid gap-y-3"
                >
                    <p v-for="item in item.moreDescription">{{ item }}</p>
                </div>
            </TransitionExpand>
            <button
                v-if="item?.moreDescription.length > 0"
                class="px-4 py-2 text-body-sm leading-4 font-medium flex text-brand-300 w-full focus:outline-none justify-start lg:justify-center"
                @click="show"
            >
                {{ showMore ? "Read Less" : "Read More" }}
            </button>
        </div>
    </section>
</template>
<script setup lang="ts">
import type { IAboutService } from "~/types/components/landings.type";

interface IProps {
    item: IAboutService;
}

defineProps<IProps>();

const showMore = ref(false);

const show = () => {
    showMore.value = !showMore.value;
};
</script>
